import { createRouter, createWebHistory } from "vue-router";
import Menu from "../views/Menu.vue";
import Home from "../views/HomePage.vue";
import Login from "../views/Log-In.vue";
import SignUp from "../views/SignUp.vue";
import VerifyEmail from "../views/VerifyEmail.vue";
import BookingDuration from "../views/BookingDuration.vue";
import Deposit from "../views/DepositPage.vue";
import AboutUs from "../views/AboutUs.vue";
import BookingPage from "../views/BookingPage.vue";
import ReservedPage from "../views/ReservedPage.vue";
import PreOrder from "../views/PreOrder.vue";
import EmptyCart from "../views/EmptyCart.vue";
import ContactUs from "../views/ContactUs.vue";
import Checkout from '../views/checkout.vue';
import ChooseTable from '../views/ChooseTable.vue';
import OrderDetails from '../views/OrderDetails.vue';
import NoOrders from '../views/NoOrders.vue';
import AdminOverview from '../views/AdminOverview.vue';
import AdminOrders from '../views/AdminOrders.vue';
import AdminOrderSummary from '../views/AdminOrderSummary.vue';
import AdminMessages from '../views/AdminMessages.vue';
import AdminLogin from '../views/AdminLogin.vue';
import ChefDashboard from '../views/ChefDashboard.vue';
import CartPage from '../views/CartPage.vue';
import DeliveryOrders from '../views/DeliveryOrders.vue';
import EditProfile from '../views/EditProfile.vue';
// import DepositPage from '../views/deposit.vue';

const routes = [
  
  { path: '/', name: 'Home', component: Home },
  { path: '/menu', name: 'Menu', component: Menu },
  { path: '/reservation', name: 'Reservation', ccomponent: ContactUs },
  { path: '/contact-us', name: 'Contact', component: ContactUs },
  { path: '/logIn', name: 'login', component: Login },
  { path: '/signup', name: 'signup', component: SignUp },
  { path: '/verifyEmail', name: 'verifyEmail', component: VerifyEmail },
  { path: '/bookingduration', name: 'bookingduration', component: BookingDuration },
  { path: '/deposit', name: 'DepositPage', component: Deposit },
  { path: '/aboutus', name: 'AboutUs', component: AboutUs },
  { path: '/booking', name: 'BookingPage', component: BookingPage },
  { path: '/reserved', name: 'reserved', component: ReservedPage },
  { path: '/preorder', name: 'PreOrder', component: PreOrder },
  { path: '/checkout', name: 'checkout', component: Checkout },
  { path: "/empty-cart", name: "EmptyCart", component: EmptyCart },
  { path: '/choose-table', name: 'ChooseTable', component: ChooseTable },
  { path: '/order-details', name: 'OrderDetails', component: OrderDetails },
  { path: '/no-orders', name: 'NoOrders', component: NoOrders },
  { path: '/admin', name: 'AdminOverview', component: AdminOverview },
  { path: '/admin/dashboard', name: 'AdminDashboard', component: AdminOverview },
  { path: '/admin/orders', name: 'AdminOrders', component: AdminOrders },
  { path: '/admin/order-summary', name: 'AdminOrderSummary', component: AdminOrderSummary },
  { path: '/admin/messages', name: 'AdminMessages', component: AdminMessages },
  { path: '/admin/login', name: 'AdminLogin', component: AdminLogin },
  { path: '/chef/dashboard', name: 'ChefDashboard', component: ChefDashboard },
  { path: '/cart', name: 'CartPage', component: CartPage },
  { path: '/delivery-orders', name: 'DeliveryOrders', component: DeliveryOrders },
  { path: '/edit-profile', name: 'EditProfile', component: EditProfile },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
